import useSecuredApiService from './useSecuredApiService'

const useConsignmentService = () => {
  const { getApiData, postApiData, getApiDataWithParams, patchApiData, putApiData } =
    useSecuredApiService()

  const getPaged = async (params) => {
    return await getApiDataWithParams('/Consignment/getPaged', params)
  }
  const getAll = async () => {
    return getApiData('/Consignment/getAll')
  }
  const getById = async (id) => {
    return getApiData('/Consignment/GetById?id=' + id)
  }
  const getCloneById = async (id) => {
    return getApiData('/Consignment/GetCloneById?id=' + id)
  }
  const getSummaryById = async (id) => {
    return getApiData('/Consignment/GetSummaryById?id=' + id)
  }
  const getDetailsById = async (id) => {
    return getApiData('/Consignment/GetDetailsById?id=' + id)
  }
  const create = async (data) => {
    return postApiData('/Consignment/Create', data)
  }
  const complete = async (data) => {
    return patchApiData('/Consignment/Complete', data)
  }
  const update = async (id, data) => {
    return putApiData('/Consignment/Edit?id=' + id, data)
  }

  return {
    getPaged,
    getById,
    getCloneById,
    getAll,
    create,
    update,
    complete,
    getSummaryById,
    getDetailsById,
  }
}

export default useConsignmentService
